module.exports = __webpack_public_path__ + "media/images/icons/person-56ffa1542074bc9b8422bf4240c435d8.svg";